import { useState } from 'react'
import { Card } from './Card.js'

interface Metric {
  value: string | number
  label: string
}

interface HeroCardProps {
  label: string
  title: string
  photoUrl?: string | null
  metrics: [Metric, Metric, Metric]
}

export function HeroCard({ label, title, photoUrl, metrics }: HeroCardProps) {
  const [photoErr, setPhotoErr] = useState(false)

  return (
    <Card size="hero" tone="gradient" className="p-6 relative overflow-hidden">
      <span
        aria-hidden
        className="absolute top-3 right-3 w-4 h-4 border-r border-t border-white/20"
      />
      <span
        aria-hidden
        className="absolute bottom-3 left-3 w-4 h-4 border-l border-b border-white/20"
      />

      <div className="flex items-center gap-4 mb-6">
        {photoUrl && !photoErr ? (
          <img
            src={photoUrl}
            alt={title}
            onError={() => setPhotoErr(true)}
            className="w-14 h-14 rounded-2xl object-cover shrink-0 ring-1 ring-white/20"
          />
        ) : (
          <div className="w-14 h-14 rounded-2xl bg-white/15 flex items-center justify-center shrink-0 text-white font-semibold text-xl">
            {title.charAt(0).toUpperCase()}
          </div>
        )}
        <div>
          <p className="text-white/60 text-[10px] uppercase tracking-wider font-semibold mb-1">
            {label}
          </p>
          <h1 className="text-2xl font-bold text-white leading-tight">
            {title}
          </h1>
        </div>
      </div>

      <div className="flex gap-0 divide-x divide-white/20">
        {metrics.map((m, i) => (
          <div
            key={m.label}
            className={`flex-1 ${i === 0 ? 'pr-5' : i === metrics.length - 1 ? 'pl-5' : 'px-5'}`}
          >
            <div className="text-3xl font-bold text-white tabular-nums">
              {m.value}
            </div>
            <div className="text-white/60 text-xs mt-1">{m.label}</div>
          </div>
        ))}
      </div>
    </Card>
  )
}
